// TODO: use real string based enums (available sine typescript 1.4) if
// [tslint](https://github.com/palantir/tslint/issues/2993) and more important
// [rollup](https://github.com/angular/angular/issues/17516) support it
export enum KeyboardClassKey {
  Alt = 'Alt',
  AltGr = 'AltGraph',
  AltLk = 'AltLk',
  Bksp = 'Backspace',
  Caps = 'CapsLock',
  Enter = 'Enter',
  Shift = 'Shift',
  Space = ' ',
  Tab = 'Tab',
}
